import * as React from 'react';
import classnames from 'classnames';

import { __t, applyTranslations } from 'utils/language';
import { DELIVERABLE_ATTACHMENT_TYPE_ANALYTICS } from 'utils/deliverables';

import { ModalFrameHeader, ModalFrameMessage } from 'components/modal';

import type { DeliverableAttachmentType, DeliverableType } from 'types';

applyTranslations(require('./deliverable-attachment-feedback-modal.i18n.json'));

type Props = {
  attachmentType: DeliverableAttachmentType,
  deliverableType: DeliverableType
};

class DeliverableAttachmentFeedbackModal extends React.PureComponent<Props> {
  render() {
    const { attachmentType, deliverableType } = this.props;
    const mappedDeliverableType = deliverableType?.replace('_regram', '');

    const title = __t(`deliverable_attachment_feedback_modal.${mappedDeliverableType}.title_${attachmentType}`);
    const message = __t(`deliverable_attachment_feedback_modal.${mappedDeliverableType}.message_${attachmentType}`);

    const imageClasses = classnames({
      'deliverable-attachment-feedback-modal__image': true,
      [`deliverable-attachment-feedback-modal__image--${mappedDeliverableType}`]: mappedDeliverableType
    });

    return (
      <section className="deliverable-attachment-feedback-modal">
        {
          attachmentType === DELIVERABLE_ATTACHMENT_TYPE_ANALYTICS &&
            <div className={imageClasses} />
        }
        <ModalFrameHeader
          title={title}
        />
        <ModalFrameMessage
          message={message}
        />
      </section>
    );
  }
}

export default DeliverableAttachmentFeedbackModal;
